const INVESTIGATE_FIELD = 'logzio-investigate';
// A Map, not an object: lookups are keyed by arbitrary log field names, and a plain object
// would resolve inherited members — a field named `constructor` or `toString` would match.
const linksByField = new Map([
    [
        INVESTIGATE_FIELD,
        {
            field: INVESTIGATE_FIELD,
            linkText: 'Investigate',
            columnHeader: 'Investigate',
            // The stored value is already a URL query string produced by alerting.
            buildHref: ({ value, origin }) => `${origin}/360/view-investigate-alert?${value}`,
        },
    ],
]);
/**
 * The single definition of which log fields render as links, shared by Explore's logs table
 * and the Unified Dashboards logs table panel so the two cannot drift apart.
 */
export const logFieldLinks = {
    get: (field) => linksByField.get(field),
    has: (field) => linksByField.has(field),
    fields: () => [...linksByField.keys()],
    columnHeaders: () => Object.fromEntries([...linksByField.values()].map(link => [link.field, link.columnHeader])),
};
//# sourceMappingURL=log-field-links.util.js.map